import { supabase } from './config';
import { API_ENDPOINTS } from './config';
import { handleApiError } from './error';
import type { Profile } from '../types/database';

export const profilesApi = {
  getProfile: async (userId: string) => {
    try {
      const { data, error } = await supabase
        .from(API_ENDPOINTS.PROFILES)
        .select('*')
        .eq('id', userId)
        .single();

      if (error) throw error;
      return data as Profile;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  updateProfile: async (userId: string, updates: Partial<Profile>) => {
    try {
      const { data, error } = await supabase
        .from(API_ENDPOINTS.PROFILES)
        .update(updates)
        .eq('id', userId)
        .select()
        .single();

      if (error) throw error;
      return data as Profile;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  checkProfileComplete: async (userId: string) => {
    try {
      const { data, error } = await supabase
        .from(API_ENDPOINTS.PROFILES)
        .select('full_name, phone_number, location')
        .eq('id', userId)
        .single();

      if (error) throw error;
      return !!(data.full_name && data.phone_number && data.location);
    } catch (error) {
      throw handleApiError(error);
    }
  }
};